import { useMutation } from '@tanstack/react-query';

import { EditFunnelData, Funnel } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const editFunnel = (data: EditFunnelData): Promise<{ funnel: Funnel }> => {
  return axios.put(`/funnel`, data);
};

type EditFunnelOptions = {
  pageId: string;
  onSuccess: () => void;
  config?: MutationConfig<typeof editFunnel>;
};

export function useEditFunnel({ config = {}, pageId, onSuccess }: EditFunnelOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['funnels', pageId]);
      onSuccess();
    },
    ...config,
    mutationFn: editFunnel,
  });
}
